// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Tell the server the browser's time zone so admin dates are entered and shown in
// local time (Admin::BaseController#use_browser_time_zone). If the cookie was
// missing or stale, this page was rendered in the wrong zone, so load it again.
;(function () {
  var zone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (!zone) return

  var current = function () {
    var match = document.cookie.match(/(?:^|; )time_zone=([^;]*)/)
    return match && decodeURIComponent(match[1])
  }
  if (current() === zone) return

  document.cookie = "time_zone=" + encodeURIComponent(zone) + "; path=/; max-age=31536000; SameSite=Lax"
  // Only reload if the cookie stuck, or a browser blocking cookies would loop.
  if (current() === zone) window.location.reload()
})()


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


import "bootstrap"

// Add to enable jQuery
require("jquery")